import React, { useLayoutEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import PinCodeKeyPads from "./PinCodeKeyPads"
import { closePinModal, openPinModal } from "@redux"
import classes from "./index.module.scss"

const array = [1, 2, 3, 4]

const PcPinCodeModal = () => {
  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const cashierPin =
    useSelector(state =>
      state.userAccountInfo.cashierPin
    )

  const open = useSelector(state => state.pinModal.open)

  const [pin, setPin] = useState("")
  const [showError, setShowError] = useState(false)

  useLayoutEffect(() => {
    dispatch(
      !!cashierPin ? openPinModal() : closePinModal()
    )
  }, [cashierPin])

  if (!open) return null

  const dir = i18n.dir(i18n.language)

  const isLtr = dir === "ltr"

  return (
    <div id="pin-modal" className={classes["container"]}>
      <div className={classes["header"]}>
        <div className={classes["title"]}>
          {t("پین_کد_را_وارد_کنین")}
        </div>
        <div className={clsx(classes["circules"], isLtr && classes["circules-ltr"])}>
          {array.map((_, i) =>
            <div
              key={i}
              className={clsx(
                classes["circule"],
                isLtr && classes["circule-ltr"],
                !!pin[i] && classes["active"]
              )}
            />
          )}
        </div>
        {
          showError &&
          <div className={classes["error"]}>
            {t("کد_درست_نیست")}
          </div>
        }
      </div>

      <PinCodeKeyPads
        pin={pin}
        setPin={setPin}
        setShowError={setShowError}
      />
    </div>
  )
}

export default PcPinCodeModal